
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IgnoreRuleDeleteModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    confirm(): void {
      this.$emit('delete')
    }
  }
})
